<!-- TODO: need correct -->
<rx-col class="bottom-bar-container" [class.show]="(item && item.length > 0) || !item || forceShow">
  <rx-row class="bottom-bar" [class.inactive]="item && item.length === 0">
    <rx-row class="jcfe flex-nosize" [class.fixed-block]="deselectable">
      <ng-container *ngIf="item && counter">
        <rx-icon
          *ngIf="deselectable"
          class="ml20 mr5 light"
          [name]="iconClose || 'icon-cross-circle'"
          [class.red]="item.length > 0 && !iconClose"
          [matTooltip]="'Deselect ' + selectedTitle"
          (click)="deselectTemplatesClicked()"
        ></rx-icon>
        <rx-button>
          <rx-badge class="mr10" [class.gray]="item.length === 0">
            {{ item.length }}
          </rx-badge>
          <div class="fs12 selected-title">
            {{ selectedTitle }}
          </div>
        </rx-button>
      </ng-container>
    </rx-row>

    <rx-row class="jcc">
      <ng-content></ng-content>
    </rx-row>

    <rx-row class="jcfe flex-nosize fixed-block">
      <!-- TODO: hide 'help' button RWE_1373 -->
      <!-- <rx-button
                icon="icon-facebook"
                class="capsule blue text-large"
                (click)="onHelp()">
                Help
            </rx-button> -->
    </rx-row>
  </rx-row>
</rx-col>
